export default {"src":"/_next/static/media/phasing.19dbd62f.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};